import React from 'react'
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'
import ErrorPage from '../error'
import style from './index.scss'

const OnboardingPage: React.FC = (props) => {
  return (
    <SentryErrorBoundary fallback={<ErrorPage />}>
      <div className={style.onboardingPage}>{props.children}</div>
    </SentryErrorBoundary>
  )
}

export default OnboardingPage
